import Login from 'scenes/authentication/Login'
import ForgotPassword from 'scenes/authentication/ForgotPassword'
import ResetPassword from 'scenes/authentication/ResetPassword'

import Home from 'scenes/courseEditor/Home'

import Challenges from 'scenes/admin/challenges/Challenges'
import ChallengeForm from 'scenes/admin/challenges/ChallengeForm'
import Challenge from 'scenes/admin/challenges/Challenge'

import ClubSearch from 'scenes/admin/clubs/ClubSearch'
import ClubCourses from 'scenes/admin/clubs/ClubCourses'
import CourseSearch from 'scenes/admin/courses/CourseSearch'
import CourseEditorSearch from 'scenes/courseEditor/CourseSearch/CourseEditorSearch'
import Course from 'scenes/admin/courses/Course'

import GameSearch from 'scenes/admin/games/GameSearch'
import GameSettings from 'scenes/admin/games/GameSettings'
import GameWebLeaderboard from 'scenes/admin/games/GameWebLeaderboard'

import UserSearch from 'scenes/admin/users/UserSearch'
import User from 'scenes/admin/users/User'
import Administrators from 'scenes/admin/administrators/Administrators'

import {
  HomeIcon,
  RankingIcon,
  GroupIcon,
  ReportsIcon,
  TournamentIcon,
  SingleRoundIcon,
  SupportMenuIcon,
  TipsIcon,
} from 'assets/icons'
import Tips from 'scenes/courseEditor/Tips'
import Support from 'scenes/courseEditor/Support'
import CourseDataEditor from 'scenes/courseEditor/CourseDataEditor'
import { Navigate, Route } from 'react-router-dom'
import ErrorElement from 'scenes/error/ErrorElement'
import GuestAppContainer from 'components/layout/GuestAppContainer'
import AdminRoute from 'components/route/AdminRoute'
import UserRoute from 'components/route/UserRoute'
import AuthGuard from 'scenes/authentication/AuthGuard'
import AdminPrivilegeGuard from 'components/route/AdminPrivilegeGuard'
import AdminCourseEditorGuard from 'components/route/AdminCourseEditorGuard'
import Logout from 'scenes/authentication/Logout'
import CourseGpsEditorWrapper from 'scenes/gps-editor/CourseGpsEditorWrapper'
import { PrivilegeIcon } from 'assets/icons/PrivilegeIcon'
import Privileges from 'scenes/admin/privileges/Privileges'
import ChallengeReadOnly from 'scenes/admin/challenges/ChallengeReadOnly'
import ChallengeLeaderboard from 'components/challenge/ChallengeLeaderboard'
import UserChallengeLeaderboard from 'components/userChallenge/UserChallengeLeaderboard'

export const publicRoutes: AppRoute[] = [
  {
    path: '/',
    component: Login,
    titleId: 'strings.login',
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    titleId: 'strings.forgotPassword',
  },
  {
    path: '/reset-password/:resetToken',
    component: ResetPassword,
    titleId: 'strings.resetPassword',
  },
  {
    path: '/logged-out',
    component: Logout,
    titleId: 'strings.logout',
  },
  {
    path: '/callback',
    component: Login,
    titleId: 'strings.callback',
  },
]

export const adminRoutes: AppRoute[] = [
  {
    titleId: 'strings.dashboard',
    path: '/admin/dashboard',
    component: Navigate,
    redirectTo: '/admin/users',
    showInMenu: true,
    menuIcon: HomeIcon,
    disabled: true,
    notEntryRoute: true,
  },
  {
    titleId: 'strings.users',
    path: '/admin/users/:id/:page?',
    component: User,
  },
  {
    titleId: 'strings.users',
    path: '/admin/users',
    component: UserSearch,
    showInMenu: true,
    menuIcon: GroupIcon,
  },
  {
    titleId: 'strings.gameSettings',
    path: '/admin/games/:id/settings',
    component: GameSettings,
  },
  {
    titleId: 'strings.games',
    path: '/admin/games',
    component: GameSearch,
    showInMenu: true,
    menuIcon: RankingIcon,
  },
  {
    titleId: 'strings.administrators',
    path: '/admin/administrators',
    component: Administrators,
    showInMenu: true,
    menuIcon: ReportsIcon,
  },
  {
    titleId: 'strings.privileges',
    path: '/admin/privilege',
    component: Privileges,
    showInMenu: true,
    menuIcon: PrivilegeIcon,
  },
  {
    titleId: 'strings.pastChallenges',
    path: '/admin/challenges/past',
    component: Challenges,
  },
  {
    titleId: 'strings.addNewChallenge',
    path: '/admin/challenges/new',
    component: ChallengeForm,
  },
  {
    titleId: 'strings.challenge',
    path: '/admin/challenges/v1/:id',
    component: Challenge,
  },
  {
    titleId: 'strings.challenge',
    path: '/admin/challenges/:id',
    component: ChallengeLeaderboard,
  },
  {
    titleId: 'strings.challenge',
    path: '/admin/user-challenges/:id',
    component: UserChallengeLeaderboard,
  },
  {
    titleId: 'strings.editChallenge',
    path: '/admin/challenges/:id/edit',
    component: ChallengeForm,
  },
  {
    titleId: 'strings.viewChallengeSettings',
    path: '/admin/challenges/:id/view-settings',
    component: ChallengeReadOnly,
  },
  {
    titleId: 'strings.challenges',
    path: '/admin/challenges',
    component: Challenges,
    showInMenu: true,
    menuIcon: TournamentIcon,
  },
  {
    titleId: 'strings.clubsAndCourses',
    path: '/admin/clubs/courses',
    component: CourseSearch,
  },
  {
    titleId: 'strings.clubsAndCourses',
    path: '/admin/clubs/:clubId/courses/new',
    component: Course,
  },
  {
    titleId: 'strings.clubsAndCourses',
    path: '/admin/clubs/:clubId/courses/:courseId',
    component: Course,
  },
  {
    titleId: 'strings.clubsAndCourses',
    path: '/admin/clubs/:id/courses',
    component: ClubCourses,
  },
  {
    titleId: 'strings.clubsAndCourses',
    path: '/admin/clubs',
    component: ClubSearch,
    showInMenu: true,
    menuIcon: SingleRoundIcon,
  },
  {
    titleId: 'strings.leaderboard',
    path: '/admin/games/:id/leaderboard',
    component: GameWebLeaderboard,
    notEntryRoute: true,
    outsideLayout: true,
  },
  {
    titleId: 'strings.courseGpsEditor',
    path: '/admin/courses/gps-editor',
    component: CourseGpsEditorWrapper,
    notEntryRoute: true,
    outsideLayout: true,
  },
]

export const adminCourseEditorRoutes: AppRoute[] = [
  {
    titleId: 'strings.dashboard',
    path: '/admin/dashboard',
    component: Navigate,
    redirectTo: '/admin/clubs',
    showInMenu: true,
    menuIcon: HomeIcon,
    disabled: true,
    notEntryRoute: true,
  },
  {
    titleId: 'strings.clubsAndCourses',
    path: '/admin/clubs/courses',
    component: CourseSearch,
  },
  {
    titleId: 'strings.clubsAndCourses',
    path: '/admin/clubs/:clubId/courses/new',
    component: Course,
  },
  {
    titleId: 'strings.clubsAndCourses',
    path: '/admin/clubs/:clubId/courses/:courseId',
    component: Course,
  },
  {
    titleId: 'strings.clubsAndCourses',
    path: '/admin/clubs/:id/courses',
    component: ClubCourses,
  },
  {
    titleId: 'strings.clubsAndCourses',
    path: '/admin/clubs',
    component: ClubSearch,
    showInMenu: true,
    menuIcon: SingleRoundIcon,
  },
  {
    titleId: 'strings.courseGpsEditor',
    path: '/admin/courses/gps-editor',
    component: CourseGpsEditorWrapper,
    notEntryRoute: true,
    outsideLayout: true,
  },
]

export const userRoutes: AppRoute[] = [
  {
    titleId: 'strings.home',
    path: '/course-editor',
    component: Home,
    showInMenu: true,
    menuIcon: HomeIcon,
  },
  {
    titleId: 'strings.home',
    path: '/course-editor/search',
    component: CourseEditorSearch,
    showInMenu: false,
  },
  {
    titleId: 'strings.tips',
    path: '/tips',
    component: Tips,
    showInMenu: true,
    menuIcon: TipsIcon,
  },
  {
    titleId: 'strings.support',
    path: '/support',
    component: Support,
    showInMenu: true,
    menuIcon: SupportMenuIcon,
  },
  {
    titleId: 'strings.course',
    path: '/course-editor/courses/:id',
    component: CourseDataEditor,
    showInMenu: false,
  },
  {
    titleId: 'strings.courseGpsEditor',
    path: '/course-editor/gps',
    component: CourseGpsEditorWrapper,
    notEntryRoute: true,
    outsideLayout: true,
  },
]

export const renderRoutes = () => {
  return (
    <Route errorElement={<ErrorElement />}>
      <Route element={<GuestAppContainer />}>
        {publicRoutes.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              element={route.redirectTo ? <route.component to={route.redirectTo} /> : <route.component />}
              handle={{ path: route.path, titleId: route.titleId }}
            />
          )
        })}
      </Route>
      <Route element={<AuthGuard />}>
        <Route element={<AdminPrivilegeGuard />}>
          <Route element={<AdminCourseEditorGuard />}>
            {adminCourseEditorRoutes.map((route, index) => {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={route.redirectTo ? <route.component to={route.redirectTo} /> : <route.component />}
                  handle={{
                    path: route.path,
                    titleId: route.titleId,
                    showInMenu: route.showInMenu,
                    menuIcon: route.menuIcon,
                    notEntryRoute: route.notEntryRoute,
                    disabled: route.disabled,
                    outsideLayout: route.outsideLayout,
                  }}
                />
              )
            })}
          </Route>
          <Route element={<AdminRoute />}>
            {adminRoutes.map((route, index) => {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={route.redirectTo ? <route.component to={route.redirectTo} /> : <route.component />}
                  handle={{
                    path: route.path,
                    titleId: route.titleId,
                    showInMenu: route.showInMenu,
                    menuIcon: route.menuIcon,
                    notEntryRoute: route.notEntryRoute,
                    disabled: route.disabled,
                    outsideLayout: route.outsideLayout,
                  }}
                />
              )
            })}
          </Route>
        </Route>
      </Route>
      <Route element={<AuthGuard />}>
        <Route element={<UserRoute />}>
          {userRoutes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                element={route.redirectTo ? <route.component to={route.redirectTo} /> : <route.component />}
                handle={{
                  path: route.path,
                  titleId: route.titleId,
                  showInMenu: route.showInMenu,
                  menuIcon: route.menuIcon,
                  notEntryRoute: route.notEntryRoute,
                  disabled: route.disabled,
                  outsideLayout: route.outsideLayout,
                }}
              />
            )
          })}
        </Route>
      </Route>
    </Route>
  )
}
